import { useEffect, useRef, useState } from "react";
import "../App.css";
import { toast } from "react-toastify";
import { AddCircleOutlineRounded } from "@mui/icons-material";
import "./Section.css";
import addImageIcon from "../assets/icons/add-image.png";
import { FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import EducationsDataTable from "../components/data-tables/EducationsDataTable";
import SelectCategory from "../components/select-category/SelectCategory";
import { API } from "../assets/staticData";
import SelectLang from "../components/select-lang/SelectLang";
import KeywordInput from "../components/keyword-input/KeywordInput";
import AddCat from "../components/add-cat/AddCat";
import TextEditor from "../components/rich-text/TextEditor/TextEditor";
import { createSlug } from "../utils/slug";
import ClearCacheButton from "../components/ClearCacheButton/ClearCacheButton";
import { CACHE_KEY } from "../constant/cache-key";
import { tableQueryBuilder } from "../hooks/tableQueryBuilder";
import useTableQuerySaver from "../hooks/useTableQuerySaver";
import { useTableQueryBuilder } from "../hooks/useQueryBuilder";

let userToken = localStorage.getItem("userToken");

const headers = {
  Authorization: `Bearer ${userToken}`,
};

export default function Education({ user }) {
  const [error, setError] = useState(null);
  const [platforms, setPlatforms] = useState([]);
  const [meta, setMeta] = useState({
    pagination: {
      page: 0,
      pageSize: 0,
      pageCount: 0,
      total: 0
    }
  })
  const [loading, setLoading] = useState(false);
  const [openAdd, setOpenAdd] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [cat, setCat] = useState("");
  const [refreshCats, setRefreshCats] = useState(false);
  const [lang, setLang] = useState("");
  const [keywords, setKeywords] = useState([]);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [image, setImage] = useState(null);
  const [userInfo, setuserInfo] = useState();
  const formData = new FormData();
  const hiddenFileInput = useRef();

  const [data, setData] = useState({
    title: "",
    slug: "",
    subTitle: "",
    content: "",
    styles: "",
    summary: "",
    authorOpinion: "",
    metaTitle: "",
    metaDesc: "",
    socialTitle: "",
    socialDesc: "",
    metaKeywords: "",
    schema: "",
  });

  const queryBuilder = useTableQueryBuilder()

  async function getData(filters = { page: 0 }) {
    try {
      const {
        page = 0,
        search
      } = filters
      setLoading(true)

      let url = `${API}/articles?populate=*&sort=createdAt:desc`
      const createdQuery = queryBuilder
        .createQuery({
          pagination: { page, pageSize: 10 },
          search: {
            field: "title",
            value: search
          }
        })

      url = queryBuilder.join(url, createdQuery)

      const res = await fetch(url, {
        headers,
        method: "GET",
      })

      const respone = await res.json()
      setPlatforms(respone.data);
      setMeta(respone.meta)

      setLoading(false)
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }

  useEffect(() => {
    async function getUser() {
      fetch(`${API}/users/me?populate=*`, {
        headers,
        method: "GET",
      }).then(async (res) => {
        const respone = await res.json();
        setuserInfo(respone);
      });
    }

    async function getUsers() {
      fetch(`${API}/users`, {
        headers,
        method: "GET",
      }).then(async (res) => {
        const response = await res.json();
        setUsers(response);
      });
    }

    getData();
    getUser();
    getUsers();
  }, [refresh]);

  if (error) {
    return <div>An error occured: {error.message}</div>;
  }

  const handleInputChange = (field, value) => {
    setData({
      ...data,
      [field]: value,
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      setImage(file);
    }
  };

  const automateSlug = (title) => {
    const slug = createSlug(title);

    setData({
      ...data,
      slug,
    });
  };

  const handleError = (error) => {
    console.error("Error updating entry:", error);
    toast("Error updating entry", {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      type: "error",
    });
  };

  const uploadItem = (publish) => {
    if (
      data.title !== "" &&
      data.slug !== "" &&
      data.subTitle !== "" &&
      data.summary !== "" &&
      data.authorOpinion !== "" &&
      image !== null &&
      image !== "" &&
      cat !== "" &&
      lang !== ""
    ) {

      formData.append("files.image", image, image.name);
      formData.append(
        "data",
        JSON.stringify({
          ...data,
          slug: createSlug(data.slug),
          category_relation: cat.id,
          category: cat?.attributes?.category,
          lang: lang,
          keywords: keywords,
          likes: 0,
          users_permissions_user: selectedUser || userInfo.id,
          public: publish ? true : false,
        })
      );

      fetch(`${API}/articles`, {
        headers,
        method: "POST",
        body: formData,
      })
        .then((response) => {
          // 1. Check if the status is NOT 2xx
          if (!response.ok) {
            // This will trigger the .catch() block below
            throw response;
          }
          return response.json(); // Continue to next .then if successful
        })
        .then((data) => {
          // This only runs if response.ok was true
          setData({
            title: "",
            slug: "",
            subTitle: "",
            content: "",
            summary: "",
            authorOpinion: "",
          });
          setImage(null);
          setCat("");
          setSelectedUser("");
          setKeywords([]);
          setLang("");
          setOpenAdd(false);
          setRefresh(!refresh);

          toast("The Article was successfully added", {
            position: "top-center",
            theme: "light",
          });
        })
        .catch(async (error) => {
          // Handle the error here
          if (error instanceof Response) {
            const errorData = await error.json();
            const message = errorData?.error?.message || "Something went wrong";
            toast.error(message);
          } else {
            handleError(error);
          }
        });

    } else {
      toast("Please fill the required fields", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        type: "error",
      });
    }
  };

  const onFetchArticles = async ({ page, pageSize, search }) => {
    await getData({ page: page + 1, pageSize, search })
  }

  return (
    <div className="App">
      <div>
        <ClearCacheButton keys={[
          CACHE_KEY.articles,
          CACHE_KEY.startupConfigs
        ]} />

        <h3 style={{ textAlign: "start", marginBottom: 10 }}>Articles Content Settings</h3>

        {user.perms[17].add && (
          <div
            className="addC"
            style={{ minHeight: openAdd ? 500 : 50, padding: openAdd ? 20 : 0 }}>
            {openAdd && (
              <div
                className="fadeIn"
                style={{
                  marginTop: 10,
                  marginBottom: 20,
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  alignItems: "center",
                }}>
                <div style={{ width: "100%", display: "flex" }}>
                  <div style={{ width: "50%", height: "100%" }}>
                    <TextField
                      label="Title"
                      sx={{ width: "90%" }}
                      size="small"
                      value={data.title}
                      onChange={(e) => handleInputChange("title", e.target.value)}
                    />

                    <TextField
                      label="Slug"
                      sx={{ width: "90%", mt: 2 }}
                      size="small"
                      value={data.slug}
                      onChange={(e) => handleInputChange("slug", e.target.value)}
                    />
                    <div
                      className="mt-1 mr-6 cursor-pointer"
                      onClick={() => automateSlug(data.title)}>
                      <p className="text-sm text-right text-sky-700 underline">Automate Slug</p>
                    </div>
                    <TextField
                      label="Subtitle"
                      sx={{ width: "90%", mt: 2, mb: 2 }}
                      size="small"
                      multiline
                      rows={5}
                      value={data.subTitle}
                      onChange={(e) => handleInputChange("subTitle", e.target.value)}
                    />
                    <KeywordInput keywords={keywords} setKeywords={setKeywords} />
                  </div>
                  <div
                    style={{
                      width: "50%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: 10,
                    }}>
                    <div
                      style={{
                        border: "dashed",
                        borderWidth: 1,
                        borderColor: "grey",
                        height: 135,
                        marginTop: 1,
                        width: "90%",
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "column",
                        justifyContent: "center",
                        borderRadius: 5,
                        cursor: "pointer",
                      }}
                      onClick={() => hiddenFileInput.current.click()}>
                      {image ? (
                        <img
                          src={URL.createObjectURL(image)}
                          style={{
                            width: 55,
                            aspectRatio: 1,
                            borderRadius: 55,
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <img src={addImageIcon} style={{ width: 55 }} />
                      )}
                      <p style={{ color: "#888", fontSize: 13 }}>Click here to add an image</p>
                      <input
                        type="file"
                        accept="image/png, image/jpeg"
                        onChange={handleImageChange}
                        ref={hiddenFileInput}
                        style={{ display: "none" }}
                      />
                    </div>

                    <SelectLang lang={lang} setLang={setLang} />
                    <SelectCategory cat={cat} setCat={setCat} refreshCats={refreshCats} />
                    <AddCat refreshCats={refreshCats} setRefreshCats={setRefreshCats} />

                    {(userInfo?.id === 40 || userInfo?.id === 36) && (
                      <FormControl sx={{ width: "90%", mt: 2 }}>
                        <InputLabel id="author-select-label">Select Author</InputLabel>
                        <Select
                          labelId="author-select-label"
                          id="author-select"
                          value={selectedUser}
                          label="Select Author"
                          onChange={(e) => {
                            setSelectedUser(e.target.value);
                          }}>
                          {users.map((user) => (
                            <MenuItem key={user.id} value={user.id}>
                              {user.username}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  </div>
                </div>

                <div
                  className="mt-4"
                  style={{
                    width: "100%",
                  }}>
                  <TextEditor
                    init={{ min_height: 800 }}
                    value={data.content}
                    onChange={(val) => handleInputChange("content", val)}
                  />
                </div>

                <div
                  className="flex"
                  style={{
                    width: "100%",
                    marginTop: 10,
                    justifyContent: "space-between",
                  }}>
                  <TextField
                    label="Summary"
                    sx={{ width: "48%", mt: 2, mb: 2 }}
                    size="small"
                    multiline
                    rows={5}
                    value={data.summary}
                    onChange={(e) => handleInputChange("summary", e.target.value)}
                  />
                  <TextField
                    label="Author's Opinion"
                    sx={{ width: "48%", mt: 2, mb: 2 }}
                    size="small"
                    multiline
                    rows={5}
                    value={data.authorOpinion}
                    onChange={(e) => handleInputChange("authorOpinion", e.target.value)}
                  />
                </div>

                <h3 style={{ alignSelf: "flex-start", marginTop: 10 }}>SEO Configuration</h3>
                <div
                  className="flex"
                  style={{
                    width: "100%",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                  }}>
                  <TextField
                    label="Meta Title"
                    sx={{ width: "48%", mt: 2, mb: 2 }}
                    value={data.metaTitle}
                    onChange={(e) => handleInputChange("metaTitle", e.target.value)}
                  />
                  <TextField
                    label="Social Title"
                    sx={{ width: "48%", mt: 1, mb: 2 }}
                    value={data.socialTitle}
                    onChange={(e) => handleInputChange("socialTitle", e.target.value)}
                  />
                  <TextField
                    label="Meta Description"
                    sx={{ width: "48%", mt: 2, mb: 2 }}
                    size="small"
                    multiline
                    rows={3}
                    value={data.metaDesc}
                    onChange={(e) => handleInputChange("metaDesc", e.target.value)}
                  />
                  <TextField
                    label="Social Description"
                    sx={{ width: "48%", mt: 1, mb: 2 }}
                    size="small"
                    multiline
                    rows={3}
                    value={data.socialDesc}
                    onChange={(e) => handleInputChange("socialDesc", e.target.value)}
                  />
                  <div style={{ width: "48%", marginTop: 17 }}>
                    <TextField
                      label="Meta Keyowrds"
                      sx={{ width: "100%" }}
                      size="small"
                      multiline
                      rows={4}
                      value={data.metaKeywords}
                      onChange={(e) => handleInputChange("metaKeywords", e.target.value)}
                    />
                    <p style={{ fontSize: 13, marginTop: 3, textAlign: "left" }}>
                      Seperate each Keyword by a ","
                    </p>
                  </div>
                  <TextField
                    label="Schema"
                    sx={{ width: "48%", mt: 1, mb: 2 }}
                    size="small"
                    multiline
                    rows={4}
                    value={data.schema}
                    onChange={(e) => handleInputChange("schema", e.target.value)}
                  />
                </div>
              </div>
            )}
            <div
              className="addBTN"
              onClick={() => (openAdd ? uploadItem(true) : setOpenAdd(true))}
              style={{ width: openAdd ? "50%" : "100%" }}>
              Publish a new Article
              <AddCircleOutlineRounded style={{ marginLeft: 7 }} />
            </div>

            {openAdd && (
              <div className="flex mt-2 w-[60%] gap-5">
                <div
                  onClick={() => uploadItem(false)}
                  className="flex w-[40%] bg-sky-600 h-[40px] text-white mt-[10px] rounded-md cursor-pointer hover:bg-sky-700 transition-all delay-100">
                  Save as Draft
                </div>
                <div
                  onClick={() => {
                    setOpenAdd(false);
                    setImage(null);
                    setKeywords([]);
                    setCat("");
                    setLang("");
                    setData({
                      title: "",
                      slug: "",
                      subTitle: "",
                      content: "",
                      summary: "",
                      authorOpinion: "",
                      metaTitle: "",
                      metaDesc: "",
                      socialTitle: "",
                      socialDesc: "",
                      metaKeywords: "",
                      schema: "",
                    });
                  }}
                  className="cancelBTN">
                  Cancel
                </div>
              </div>
            )}
          </div>
        )}

        <EducationsDataTable
          data={platforms}
          meta={meta}
          endpoint={"articles"}
          setRefresh={setRefresh}
          onChangeQuery={onFetchArticles}
          loading={loading}
          refresh={refresh}
          user={user}
          permNumber={17}
        />
      </div>
    </div>
  );
}
